import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        {/* <Link to="/">
          <Icon icon="fa-brands:facebook-f" />
        </Link>
        <Link to="/">
          <Icon icon="fa-brands:youtube" />
        </Link> */}
        <a
          href="https://www.linkedin.com/in/dr-pushpalatha-biradar-196004395/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="fa-brands:linkedin-in" />
        </a>
        {/* <Link to="/">
          <Icon icon="fa-brands:twitter" />
        </Link> */}
        <a
          href="https://www.instagram.com/pushpa.medayus/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="fa-brands:instagram" />
        </a>
      </div>
    </div>
  );
}
